//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import FooterNav from '@/components/footerNav'

export default {
  name: "Sort",
  components: {
    FooterNav
  },
  data() {
    return {
      activeId: '',
      firstClass: [],
      secondList: [],
      thirdList: [],
      imgUrl: HTTP_IMG_URL,
      selectType: 0,
      brandlist: []
    }
  },
  activated() {
    this.$store.commit('savePageType',1)
    const scrollTop = this.$route.meta.scrollTop;
    console.log(scrollTop)
    const $content = document.querySelector('#content');
    if (scrollTop && $content) {
      $content.scrollTop = scrollTop;
    }
  },
  created() {
    this.$store.commit('savePageType',1)
    this.getFirstClass();
    this.getBrandList()
  },
  methods: {
    //选择第二分类
    selectSecond(classId) {
      this.activeId = classId;
      this.$vux.loading.show({
        text: '加载数据'
      })
      this.getSecondClass(classId)
    },
    //获取第二分类
    getSecondClass(classId) {
      axiosApi.getSecondSort({classId}).then(res => {
        this.$vux.loading.hide();
        if (res.code == 0) {
          this.secondList = res.content.secondClassList || [];
          this.thirdList = res.content.ThirdClassList || [];
        }
      })
    },
    //获取第一分类
    getFirstClass() {
      axiosApi.getFirstSort().then(res => {
        if (res.code == 0) {
          this.firstClass = res.content;
          let firstClassId = res.content[0].classId
          this.activeId = firstClassId;
          this.getSecondClass(firstClassId)
        }
      })
    },
    //获取品牌列表
    getBrandList() {
      axiosApi.getBrandSort({home: 1}).then(res => {
        if (res.code == 0) {
          this.brandlist = res.content || [];
        }
      })
    },
    //Tab切换
    switchClass(type) {
      if (type == this.selectType) return
      this.selectType = type
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/sort/index.vue